import { css } from '@emotion/react';
import { DesignToken, SpacingToken } from '@livechat/design-system-react-components';

import { MEDIA_MIN_SM } from '_assets/css/breakpoints';

export const container = css`
  display: flex;
  flex-direction: column;
`;

export const detailsContainer = css`
  display: flex;
  background-color: var(${DesignToken.SurfacePrimaryDefault});
  border: 1px solid var(${DesignToken.BorderBasicSecondary});
  border-radius: var(${SpacingToken.Spacing2});
  width: 320px;
  padding: var(${SpacingToken.Spacing6});

  ${MEDIA_MIN_SM} {
    width: 724px;
    padding: var(${SpacingToken.Spacing8});
  }
`;

export const topDetailsContainer = css`
  width: 320px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  > h6 {
    color: var(${DesignToken.ContentBasicSecondary});
    margin: 0;
    text-align: left;
  }

  ${MEDIA_MIN_SM} {
    width: 100%;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin: 0 0 var(${SpacingToken.Spacing1}) 0;
  }
`;
